import React from 'react';

export const TermsConditions = () => (
  <main>
    <div className='container mg-tp-150'>
      <div className='pt-mob-4 two_column_grid pb-sm-5 pt-sm-5 pt-5 mb-mob-5 mb-sm-3 mb-md-4'>
        <div className='mb-mob-2 animated fadeInUp'>
          <div >
            <div className='col-sm-12'>
              <div>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  <strong
                    style={{
                      boxSizing: "border-box",
                      fontWeight: 600,
                      fontFamily: "Raleway",
                      color: "rgb(51, 51, 51)"
                    }}
                  >
                    <u style={{ boxSizing: "border-box" }}>ACCEPTABLE USE POLICY</u>
                  </strong>
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  This acceptable use policy sets out the terms between you and us under which
                  you may access our website www.swiss-pack.com (
                  <strong
                    style={{
                      boxSizing: "border-box",
                      fontWeight: 600,
                      fontFamily: "Raleway",
                      color: "rgb(51, 51, 51)"
                    }}
                  >
                    our site
                  </strong>
                  ). This acceptable use policy applies to all users of, and visitors to, our
                  site.
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  Your use of our site means that you accept, and agree to abide by, all the
                  policies in this acceptable use policy, which supplement our terms of
                  website use www.swiss-pack.com/policies
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  www.swiss-pack.com is a site operated by Icone International Ltd (
                  <strong
                    style={{
                      boxSizing: "border-box",
                      fontWeight: 600,
                      fontFamily: "Raleway",
                      color: "rgb(51, 51, 51)"
                    }}
                  >
                    we
                  </strong>{" "}
                  or&nbsp;
                  <strong
                    style={{
                      boxSizing: "border-box",
                      fontWeight: 600,
                      fontFamily: "Raleway",
                      color: "rgb(51, 51, 51)"
                    }}
                  >
                    us
                  </strong>
                  ). &nbsp;We are registered in England and Wales under company number
                  04675816 and we have our registered office at Unit 1, Icone House, Rosslyn
                  Crescent, Harrow, London, HA1 2SU. Our main trading address is the same as
                  our registered address, Swiss Pack &amp; Swiss Pack Europe are the trading
                  names of Icone International Ltd. Our VAT number is GB820750355.&nbsp;
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  Prohibited uses
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  You may use our site only for lawful purposes. &nbsp;You may not use our
                  site:
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    marginTop: 0,
                    marginBottom: "1rem",
                    color: "rgb(33, 37, 41)",
                    fontFamily: '"Open Sans"',
                    fontSize: 16,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    fontWeight: 400,
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    In any way that breaches any applicable local, national or international
                    law or regulation.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    In any way that is unlawful or fraudulent, or has any unlawful or
                    fraudulent purpose or effect.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    For the purpose of harming or attempting to harm minors in any way.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    To send, knowingly receive, upload, download, use or re-use any material
                    which does not comply with any of our policies set out on our policies
                    page at www.swiss-pack.com/policies
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    To transmit, or procure the sending of, any unsolicited or unauthorised
                    advertising or promotional material or any other form of similar
                    solicitation (spam).
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    To knowingly transmit any data, send or upload any material that contains
                    viruses, Trojan horses, worms, time-bombs, keystroke loggers, spyware,
                    adware or any other harmful programs or similar computer code designed to
                    adversely affect the operation of any computer software or hardware.
                  </li>
                </ul>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  You also agree:
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    marginTop: 0,
                    marginBottom: "1rem",
                    color: "rgb(33, 37, 41)",
                    fontFamily: '"Open Sans"',
                    fontSize: 16,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    fontWeight: 400,
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Not to reproduce, duplicate, copy or re-sell any part of our site in
                    contravention of the provisions of our terms of website use which can be
                    found at www.swiss-pack.com/policies
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Not to access without authority, interfere with, damage or disrupt:
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    any part of our site;
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    any equipment or network on which our site is stored;&nbsp;
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    any software used in the provision of our site; or&nbsp;
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    any equipment or network or software owned or used by any third party.
                  </li>
                </ul>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  Interactive services
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  We may from time to time provide interactive services on our site,
                  including, without limitation:
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    marginTop: 0,
                    marginBottom: "1rem",
                    color: "rgb(33, 37, 41)",
                    fontFamily: '"Open Sans"',
                    fontSize: 16,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    fontWeight: 400,
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Chat rooms, Live Chat
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Bulletin boards, Pop Ups
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Blogs, Articles &amp; News
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Video&nbsp;
                  </li>
                </ul>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  Where we do provide any interactive service, we will provide clear
                  information to you about the kind of service offered, if it is moderated and
                  what form of moderation is used (including whether it is human or
                  technical).
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  We will do our best to assess any possible risks for users (and in
                  particular, for children) from third parties when they use any interactive
                  service provided on our site, and we will decide in each case whether it is
                  appropriate to use moderation of the relevant service (including what kind
                  of moderation to use) in the light of those risks. However, we are under no
                  obligation to oversee, monitor or moderate any interactive service we
                  provide on our site, and we expressly exclude our liability for any loss or
                  damage arising from the use of any interactive service by a user in
                  contravention of our content standards, whether the service is moderated or
                  not.&nbsp;
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  The use of any of our interactive services by a minor is subject to the
                  consent of their parent or guardian. We advise parents who permit their
                  children to use an interactive service that it is important that they
                  communicate with their children about their safety online, as moderation is
                  not foolproof. Minors who are using any interactive service should be made
                  aware of the potential risks to them.&nbsp;
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  Where we do moderate an interactive service, we will normally provide you
                  with a means of contacting the moderator, should a concern or difficulty
                  arise.
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  Content standards
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  These content standards apply to any and all material which you contribute
                  to our site (
                  <strong
                    style={{
                      boxSizing: "border-box",
                      fontWeight: 600,
                      fontFamily: "Raleway",
                      color: "rgb(51, 51, 51)"
                    }}
                  >
                    contributions
                  </strong>
                  ), and to any interactive services associated with it.&nbsp;
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  You must comply with the spirit and the letter of the following standards.
                  The standards apply to each part of any contribution as well as to its
                  whole.
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  Contributions must:
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    marginTop: 0,
                    marginBottom: "1rem",
                    color: "rgb(33, 37, 41)",
                    fontFamily: '"Open Sans"',
                    fontSize: 16,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    fontWeight: 400,
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Be accurate (where they state facts).
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Be genuinely held (where they state opinions).
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Comply with applicable law in the UK and in any country from which they
                    are posted.
                  </li>
                </ul>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  Contributions must not:
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    marginTop: 0,
                    marginBottom: "1rem",
                    color: "rgb(33, 37, 41)",
                    fontFamily: '"Open Sans"',
                    fontSize: 16,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    fontWeight: 400,
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Contain any material which is defamatory of any person.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Contain any material which is obscene, offensive, hateful or inflammatory.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Promote sexually explicit material.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Promote violence.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Promote discrimination based on race, sex, religion, nationality,
                    disability, sexual orientation or age.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Infringe any copyright, database right or trade mark of any other person.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Be likely to deceive any person.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Be made in breach of any legal duty owed to a third party, such as a
                    contractual duty or a duty of confidence.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Promote any illegal activity.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Be threatening, abuse or invade another’s privacy, or cause annoyance,
                    inconvenience or needless anxiety.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Be likely to harass, upset, embarrass, alarm or annoy any other person.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Be used to impersonate any person, or to misrepresent your identity or
                    affiliation with any person.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Give the impression that they emanate from us, if this is not the case.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Advocate, promote or assist any unlawful act such as (by way of example
                    only) copyright infringement or computer misuse.
                  </li>
                </ul>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  Suspension and termination
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  We will determine, in our discretion, whether there has been a breach of
                  this acceptable use policy through your use of our site. &nbsp;When a breach
                  of this policy has occurred, we may take such action as we deem appropriate.
                  &nbsp;
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  Failure to comply with this acceptable use policy constitutes a material
                  breach of the terms of use [www.swiss-pack.com/policies] upon which you are
                  permitted to use our site, and may result in our taking all or any of the
                  following actions:
                </p>
                <ul
                  style={{
                    boxSizing: "border-box",
                    marginTop: 0,
                    marginBottom: "1rem",
                    color: "rgb(33, 37, 41)",
                    fontFamily: '"Open Sans"',
                    fontSize: 16,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    fontWeight: 400,
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Immediate, temporary or permanent withdrawal of your right to use our
                    site.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Immediate, temporary or permanent removal of any posting or material
                    uploaded by you to our site.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Issue of a warning to you.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Legal proceedings against you for reimbursement of all costs on an
                    indemnity basis (including, but not limited to, reasonable administrative
                    and legal costs) resulting from the breach.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Further legal action against you.
                  </li>
                  <li style={{ boxSizing: "border-box", fontFamily: '"Open Sans"' }}>
                    Disclosure of such information to law enforcement authorities as we
                    reasonably feel is necessary.
                  </li>
                </ul>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  We exclude liability for actions taken in response to breaches of this
                  acceptable use policy. &nbsp;The responses described in this policy are not
                  limited, and we may take any other action we reasonably deem appropriate.
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  Changes to the acceptable use policy
                </p>
                <p
                  style={{
                    boxSizing: "border-box",
                    margin: "0px 0cm 1rem",
                    fontFamily: '"Open Sans"',
                    color: "rgb(123, 133, 145)",
                    fontSize: 14,

                    fontWeight: 400,
                    fontStyle: "normal",
                    fontVariantLigatures: "normal",
                    fontVariantCaps: "normal",
                    letterSpacing: "normal",
                    orphans: 2,
                    textAlign: "left",
                    textIndent: 0,
                    textTransform: "none",
                    whiteSpace: "normal",
                    widows: 2,
                    wordSpacing: 0,
                    WebkitTextStrokeWidth: 0,
                    backgroundColor: "rgb(240, 240, 240)",
                    textDecorationStyle: "initial",
                    textDecorationColor: "initial"
                  }}
                >
                  We may revise this acceptable use policy at any time by amending this page.
                  You are expected to check this page from time to time to take notice of any
                  changes we make, as they are legally binding on you. Some of the provisions
                  contained in this acceptable use policy may also be superseded by provisions
                  or notices published elsewhere on our site.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
);
